export enum PAYMENT_STATUS {
  PAID = "Paid",
  REFUND = "Refund",
  NO_BALANCE = "Pay Later", // TODO change to better name once backend can accomodate
}

// Enumerated sad paths
// that send the user to Sorry page
export enum ExitType {
  None = -1,
  OutsideCounty,
  PartTimeResident,
  FiledSchEAnd4797,
  FiledSchE,
  Filed4797,
  NoTermsAcceptance,
  UploadedSch1WithRoyaltiesAndOtherGains,
  UploadedSch1WithRoyalties,
  UploadedSch1WithOtherGains,
  TooManyRequests,
  UserData,
  UnknownAddressVerificationError,
  UserIsAMinor,
}
